import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { postLibrary  } from '../../../store/api';
import './PromoCodeForm.css'; // Стили для формы

export const PromoCodeForm = () => {
  const [formData, setFormData] = useState({
    title: '',
    dateAcces: '',
    dateFrom: '',
    sale: '',
    description: ''
  });
  const dispatch = useDispatch()
  const { lib, statusLib, error } = useSelector(state => state.lib);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Обработчик изменений в полях формы
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Валидация формы
  const validateForm = () => {
    if (!formData.code.trim()) {
      setMessage('Введите название промокода');
      return false;
    }
    
    if (!formData.discountPercentage || formData.discountPercentage <= 0 || formData.discountPercentage > 100) {
      setMessage('Процент скидки должен быть от 1 до 100');
      return false;
    }
    
    if (!formData.validFrom || !formData.validUntil) {
      setMessage('Укажите срок действия промокода');
      return false;
    }
    
    if (new Date(formData.validUntil) <= new Date(formData.validFrom)) {
      setMessage('Дата окончания должна быть позже даты начала');
      return false;
    }
    
    return true;
  };

  // Отправка данных на сервер
   const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.dateAcces || !formData.sale ||  !formData.dateFrom) {
      alert('Заполните все поля');
      return;
    }
    dispatch(postLibrary({name: 'promocode', values: formData}))
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('ru-RU');
  };

  return (
    <div className="promo-code-form">
      <h2>Создание нового промокода</h2>
      
      {message && (
        <div className={`message ${message.includes('успешно') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Название промокода *</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="SUMMER2024"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="sale">Процент скидки *</label>
          <input
            type="number"
            id="sale"
            name="sale"
            value={formData.sale}
            onChange={handleChange}
            min="1"
            max="100"
            placeholder="10"
            required
          />
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="dateFrom">Действует с *</label>
            <input
              type="datetime-local"
              id="dateFrom"
              name="dateFrom"
              value={formData.dateFrom}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="dateAcces">Действует до *</label>
            <input
              type="datetime-local"
              id="dateAcces"
              name="dateAcces"
              value={formData.dateAcces}
              onChange={handleChange}
              required
            />
          </div>
        </div>
       
        <div className="form-group">
          <label htmlFor="description">Описание</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Описание промокода (необязательно)"
            rows="3"
          />
        </div>
        
        <button 
          type="submit" 
          className="submit-btn"
          disabled={isLoading}
        >
          {isLoading ? 'Создание...' : 'Создать промокод'}
        </button>
      </form>
       <div className="promo-list">
        <h3>Существующие промокоды:</h3>
        {lib.promocode.length === 0 ? (
          <p>Промокодов нет</p>
        ) : (
          <div className="promo-grid">
            {lib.promocode.map(promo => (
              <div key={promo._id} className="promo-card">
                <h4>{promo.title}</h4>
                <p>Скидка: {promo.sale}%</p>
                <p>Описание: {promo.description}</p>
                <p>Действует c: {formatDate(promo.dateFrom)} до: {formatDate(promo.dateAcces)}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};